<div class="prompt-editor" (dblclick)="editDetail($event)">
  <div #surface class="prompt-surface"></div>
  @if (!mounted()) {
    <textarea class="prompt-fallback" [value]="value()" [readonly]="readOnly()" (input)="onFallback($event)"></textarea>
  }
  @if (editingField()) {
    <div class="prompt-editor-actions">
      <button type="button" (click)="closeDetail()" [attr.aria-label]="'editor.fieldClose' | transloco"><mat-icon>close</mat-icon></button>
      @if (!readOnly()) {
        <button type="button" (click)="applyDetail()" [attr.aria-label]="'editor.fieldApply' | transloco"><mat-icon>check</mat-icon></button>
      }
    </div>
  }
</div>
